import { SelectionModel } from '@angular/cdk/collections';
import { Component, Inject, OnInit } from '@angular/core';
import { TRANSLATE } from '../../classes/translatable';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export class CopyValidationDialogData <T>{
  copyMessage                   = TRANSLATE("Voulez-vous vraiment copier cet élément ?");
  selection: SelectionModel<any>  = null;
  getRefToDisplay: any            = null;
  isArchive                       = false;
  isPrimary                       = false;
  buttonWording: string           = TRANSLATE('Copier');
  title: string                   = "Copier";
}

@Component({
  selector: 'app-copy-validation-dialog',
  templateUrl: './copy-validation-dialog.component.html',
  styleUrls: ['./copy-validation-dialog.component.css']
})
export class CopyValidationDialogComponent <T>implements OnInit {

  constructor(
        public dialogRef: MatDialogRef<CopyValidationDialogComponent<T>>,
        @Inject(MAT_DIALOG_DATA) public data: CopyValidationDialogData<T> = new CopyValidationDialogData()
    ) { }

  ngOnInit() {
    if (!this.data)
        this.data = new CopyValidationDialogData();
    this.dialogRef.disableClose = true;
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(true);
  }

}
